import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { Editor } from '@craftjs/core';
import { Navbar } from '@/components/navbar/Navbar/Navbar';
import { Sidebar } from '@/components/sidebar/Sidebar/Sidebar';
import { ResponsivePreviewPanel } from '@/components/widgets/ResponsivePreviewPanel/ResponsivePreviewPanel';
import InspectorLoader from '@/components/inspector/InspectorLoading/InspectorLoading';
import { selectPreviewModeEnabled } from '@/store/system/selectors';
import { selectPanZoomState } from '@/store/zoom/selectors';
import type { PanZoomState } from '@/store/zoom/panZoomSlice';
import { useAppSelector } from '@/store/hooks';
import { CanvasLoader } from '@/components/canvas/CanvasLoader/CanvasLoader';

interface LoaderProps {
  className?: string;
}

export const Loader: React.FC<LoaderProps> = ({ className }) => {
  const [frameRef] = useState<HTMLDivElement | null>(null);
  const previewMode = useAppSelector(selectPreviewModeEnabled);
  const state = useAppSelector(selectPanZoomState);
  const panZoomStateRef = useRef<PanZoomState>(state);

  useEffect(() => {
    panZoomStateRef.current = state;
  }, [state]);

  const loading = true;

  return (
    <Editor enabled={!previewMode}>
      <div className={clsx('relative h-[100vh] overflow-hidden bg-neutral-100', className)}>
        <Navbar className="mx-auto w-full" loading={loading} />
        <div className="flex justify-between">
          <Sidebar className="" loading={loading} />

          <div className="relative flex-grow">
            <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
              <CanvasLoader className="h-[calc(90vh-64px)] max-h-[832px] w-[calc(90vw-304px)] max-w-[1200px]" />
            </div>
          </div>

          {!previewMode && (
            <>
              <ResponsivePreviewPanel
                className="absolute bottom-5 left-[calc(50%-115px)] z-10"
                frameRef={frameRef}
                loading={loading}
              />
              <InspectorLoader />
            </>
          )}
        </div>
      </div>
    </Editor>
  );
};

export default Loader;
